module.exports = __webpack_public_path__ + "static/media/logo.67862914.svg";